import { useState } from "react";

const faqs = [
  {
    q: "How does FlintPay control business payments?",
    a: "FlintPay runs real-time validation checks before every payment, ensuring it matches trip details, location, time, category, and company policy."
  },
  {
    q: "What happens if a payment doesn’t match company rules?",
    a: "The transaction is blocked instantly before payment is completed, preventing non-compliant or fraudulent spend."
  },
  {
    q: "Is reimbursement still required?",
    a: "Yes, but it’s fully automated. Since employees pay via their own UPI accounts, expenses are instantly recorded and verified, and reimbursements are processed within a maximum of 30 days."
  },
  {
    q: "How are expenses recorded?",
    a: "Expenses are automatically created after a successful payment — no manual entry or receipt uploads needed."
  },
  {
    q: "How does FlintPay prevent fraud?",
    a: "FlintPay uses a 6-layer validation system including calendar checks, geo-location, time window, merchant category, policy limits, and duplicate detection."
  },
  {
    q: "How does trip integration work?",
    a: "FlintPay syncs with Google or Teams Calendar to automatically detect trips, validate expenses, and reduce manual trip creation."
  },
  {
    q: "Can managers still approve expenses?",
    a: "Yes. Managers review and approve expenses after payment, with full visibility into any flagged transactions."
  },
  {
    q: "What payment methods are supported?",
    a: "FlintPay supports UPI-based payments across all major apps, making it fast, secure, and widely accepted in India."
  },
  {
    q: "Is FlintPay secure?",
    a: "Yes. All payments use secure APIs with signature verification, encrypted data, and strict access controls with role-based permissions."
  },
  {
    q: "Who is FlintPay built for?",
    a: "FlintPay is designed for Indian SMEs with frequent business travel."
  }
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <div className="mx-auto max-w-6xl px-4 py-16">

      {/* Heading */}
      <h2 className="mb-2 text-3xl font-semibold text-primary-800">
        FAQs
      </h2>
      <p className="mb-8 text-muted">
        Got questions? We’ve got answers.
      </p>

      {/* FAQ List */}
      <div className="space-y-3">
        {faqs.map((item, i) => (
          <div
            key={i}
            className="rounded-xl border border-line bg-card transition-all duration-200"
          >
            <button
              onClick={() => setOpen(open === i ? null : i)}
              className="w-full flex items-center justify-between p-5 text-left"
            >
              <span className="font-medium text-primary-800">
                {item.q}
              </span>

              {/* Chevron */}
              <span
                className={`ml-4 transition-transform duration-300 ${open === i ? "rotate-180" : ""
                  }`}
              >
                ▼
              </span>
            </button>

            {/* Answer */}
            <div
              className={`px-5 overflow-hidden transition-all duration-300 ${open === i ? "max-h-40 pb-5" : "max-h-0"
                }`}
            >
              <p className="text-sm leading-relaxed text-muted">
                {item.a}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
